import React from "react";
import Cell from "../Cell";
import { OptionImage } from "../../../product/style";
import ModuleColorsDialog from "../ModuleColorsDialog";
import SectionColorsDialog from "../SectionColorsDialog";
import { isMobileOnly } from "react-device-detect";

const ColorCell = ({
  type,
  rowId,
  tempId,
  sectionId,
  isFillerRow = false,
  errorMessage,
  tableManager,
  propertyList,
  colorIdentifiers,
  isActive,
  dialogProps = {},
  pasteOverrides,
  onContextMenu,
  setCurrentTab,
}) => {
  const renderColorOptions = () => {
    return colorIdentifiers.map((identifier, index) => {
      const property = propertyList?.find((e) => e.identifier === identifier);
      let selectedOption;
      if (pasteOverrides) {
        const overrideValues = [
          pasteOverrides.shutter_color,
          pasteOverrides.color,
          pasteOverrides.internal_color,
        ].filter(Boolean);

        if (overrideValues.length > 0) {
          selectedOption = property?.options?.find((e) =>
            overrideValues.some((val) => val === e.identifier || val === e.name)
          );
        }
      } else {
        selectedOption = property?.options?.find((e) => e.selected);
      }
      if (type === "module") {
        if (!property || !property.is_overridden_v2 || !selectedOption) {
          return null;
        }
      } else {
        if (!property || !selectedOption) {
          return null;
        }
      }

      return (
        <OptionImage
          key={index}
          className="mt-0 rounded-circle"
          height={24}
          width={24}
          src={selectedOption.image}
          style={index === 1 ? { marginLeft: "-8px" } : {}}
        />
      );
    });
  };

  return (
    <Cell
      rowType={type}
      rowId={rowId}
      column="color"
      status="focus"
      customStyles={{ width: isMobileOnly ? "15%" : "60px" }}
      tableManager={tableManager}
      isTemp={tempId}
      errorMessage={errorMessage}
      isFillerRow={isFillerRow}
      sectionId={sectionId}
      onContextMenu={onContextMenu}
    >
      <div className="d-flex justify-content-center align-items-center position-relative">
        {!tempId && renderColorOptions()}
      </div>

      {isActive &&
        (type === "module" ? (
          <ModuleColorsDialog
            orderItem={dialogProps.orderItem}
            access={dialogProps.access}
            tableManager={tableManager}
            moduleColorIdentifiers={colorIdentifiers}
            updateModuleProperties={dialogProps.updateModuleProperties}
            toggleClearOverrideModal={dialogProps.toggleClearOverrideModal}
            setClearOverrideFunc={dialogProps.setClearOverrideFunc}
            clearModuleOverrides={dialogProps.clearModuleOverrides}
            mutateCurrentRoom={dialogProps.mutateCurrentRoom}
            isAdmin={dialogProps.isAdmin}
            setCurrentTab={setCurrentTab}
          />
        ) : (
          <SectionColorsDialog
            group={dialogProps.group}
            tableManager={tableManager}
            colorIdentifiers={colorIdentifiers}
            updateSectionProperties={dialogProps.updateSectionProperties}
            mutateCurrentRoom={dialogProps.mutateCurrentRoom}
            isAdmin={dialogProps.isAdmin}
            setCurrentTab={setCurrentTab}
          />
        ))}
    </Cell>
  );
};

export default ColorCell;
